import * as React from 'react';
import Box from '@mui/material/Box';
import Button from '@mui/material/Button';
import Typography from '@mui/material/Typography';
import Modal from '@mui/material/Modal';
import { makeStyles } from '@material-ui/core';




const useStyles = makeStyles(() => ({
  box: {
    position: 'absolute',
    top: '50%',
    left: '50%',
    transform: 'translate(-50%, -50%)',
    width: '50%',
    background: 'white',
    border: 0,
    outline: 0,
    boxShadow: 24,
    padding: '2%',
    height: '80vh',
    overflowY: 'scroll',
    border: 0,
    '@media(max-width: 900px)' : {
      width: '80%',
      padding: '10%',
      height: '70vh',
    },
  },

  p: {
    marginTop: '2%',
  },
  button: {
    marginTop: '2%',
    height: '40px',
    width: '50%',
    fontSize: '1em',
    outline: 0,
    border: '5px solid transparent',
    background: 'darkgreen',
    cursor: 'pointer',
    color: 'whitesmoke',
    transition: 'background 0.5s ease',
    '&:hover' : {
      color: 'darkgreen',
      background: 'rgba(0, 100, 0, 0.1)',
      borderBottom: '2px solid darkgreen',
    },
    '@media(max-width: 900px)' : {
      marginTop: '10%',
      width: '100%',
    },
  }
}))






export default function BasicModal(props) {

  const {image, name, description, url} = props;


  const classes = useStyles();
  const [open, setOpen] = React.useState(false);
  const handleOpen = () => setOpen(true);
  const handleClose = () => setOpen(false);

  return (
    <div>
      <button onClick={handleOpen}> View... </button>
      <Modal
        open={open}
        onClose={handleClose}
        aria-labelledby="modal-modal-title"
        aria-describedby="modal-modal-description"
      >
        <Box className={classes.box}>
          <img src={image} alt={name}/>
          <p className={classes.p}> {description} </p>
          <a href={url} target="_black"> 
            <button className={classes.button}> Live Site </button> 
          </a>
        </Box>
      </Modal>
    </div>
  );
}
